import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hizmetler from "../pages/hizmetler/page";
import HizmetDetay from "../pages/hizmetler/detay/page";
import Bizim from "../pages/bizim/page";
import Randevu from "../pages/randevu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <Hizmetler />,
  },
  {
    path: "/hizmetler/:slug",
    element: <HizmetDetay />,
  },
  {
    path: "/bizim",
    element: <Bizim />,
  },
  {
    path: "/randevu",
    element: <Randevu />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
